import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mantine/core';

import DefaultModuleLayout from './DefaultModuleLayout';
import PriceSurveysSidebar from '../navigation/PriceSurveysSidebar';
import RequestDrawer from '../requests/RequestDrawer';
import { RequestDrawerProvider } from '../../context/RequestDrawerContext';
import { PageZoomProvider } from '../../context/PageZoomContext';

function PriceSurveysLayout() {
    useEffect(() => {
        localStorage.setItem('selectedModule', 'Price Surveys');
    }, []);

    return (
        <RequestDrawerProvider>
            <DefaultModuleLayout>
                <PriceSurveysSidebar />
                <Box className="w-full bg-light-grey overflow-x-hidden overflow-y-scroll pl-[78px] h-[calc(100vh-64px)]">
                    <PageZoomProvider>
                        <Outlet />
                    </PageZoomProvider>
                </Box>
            </DefaultModuleLayout>
            <RequestDrawer />
        </RequestDrawerProvider>
    );
}

export default PriceSurveysLayout;
